/**
 * ConversationsPage — Layout Master-Detail
 *
 * Desktop (lg+):  [Lista fija 320px] | [Detalle flex-1]
 * Mobile:         lista O detalle (según URL)
 */
import { useParams } from 'react-router-dom'
import { MessageCircle } from 'lucide-react'
import ConversationsList from './ConversationsList'
import ConversationView from './ConversationView'

export default function ConversationsPage() {
  const { id } = useParams<{ id?: string }>()

  return (
    <div
      data-tour="conversations-main"
      className="flex w-full h-[calc(100svh-64px-3.5rem)] sm:h-[calc(100svh-64px-4rem)] lg:h-full overflow-hidden bg-white"
    >
      {/* ── Panel izquierdo: Lista ─────────────────────────────────── */}
      <div
        className={[
          'flex flex-col flex-shrink-0 border-r border-gray-200 bg-white overflow-hidden',
          // Mobile: oculta la lista cuando hay un id abierto
          // Desktop: siempre visible con ancho fijo
          id ? 'hidden lg:flex lg:w-80 xl:w-96' : 'flex w-full lg:w-80 xl:w-96',
        ].join(' ')}
      >
        <ConversationsList />
      </div>

      {/* ── Panel derecho: Detalle ─────────────────────────────────── */}
      <div
        data-tour="conversations-detail"
        className={[
          'flex flex-col flex-1 overflow-hidden bg-white',
          // Mobile: solo visible cuando hay id; Desktop: siempre
          id ? 'flex' : 'hidden lg:flex',
        ].join(' ')}
      >
        {id ? (
          <ConversationView />
        ) : (
          // Placeholder desktop cuando no hay chat seleccionado
          <div className="flex flex-col items-center justify-center h-full text-center p-8 select-none">
            <div className="w-20 h-20 rounded-full bg-gray-50 border border-gray-100 flex items-center justify-center mb-4">
              <MessageCircle className="h-10 w-10 text-gray-300" />
            </div>
            <p className="text-base font-medium text-gray-500">Selecciona una conversación</p>
            <p className="text-sm text-gray-400 mt-1">
              Elige un chat de la lista para comenzar a responder
            </p>
          </div>
        )}
      </div>
    </div>
  )
}
